import { PAYMENTS_LICENSES_URL } from '../../_js/base/endpoints'

export const fetchClientSecret = async (url, bodyObj) => {
  const body = JSON.stringify(bodyObj)

  const response = await fetch(url, {
    body,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
  })

  const { secret, id } = await response.json()

  if (!secret || !id) {
    return null
  }

  const newUrl = new URL(window.location.href)
  newUrl.searchParams.set('session', secret)
  newUrl.searchParams.set('id', id)
  newUrl.searchParams.delete('currency')

  window.history.pushState({}, '', newUrl)

  return { secret, id }
}

export const recreateCheckout = async (currentId, currency) => {
  const url = `${PAYMENTS_LICENSES_URL}/1/checkout/session/recreate`

  try {
    const response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({ id: currentId, currency }),
    })

    const { secret, id } = await response.json()

    if (!secret || !id) {
      return null
    }

    const newUrl = new URL(window.location.href)
    newUrl.searchParams.set('session', secret)
    newUrl.searchParams.set('id', id)

    window.history.replaceState({}, '', newUrl)

    return { secret, id }
  } catch (e) {
    return null
  }
}

export const fetchCheckoutInfo = async (id) => {
  const url = `${PAYMENTS_LICENSES_URL}/1/checkout/session?id=${id}`

  try {
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
    })

    const sessionInfo = await response.json()
    const { currency } = sessionInfo

    return { currency }
  } catch (e) {
    return null
  }
}
